import React, { Suspense, lazy } from 'react'
import { AppProvider } from '@!/providers'
import { usePaymentSettings } from '@!/Hooks'
const BookPurchase = lazy(() => import('@!/Store/Purchase/containers/BookPurchase'))

const BookPurchaseApp = (props) => {
  const jotaiStore = usePaymentSettings({
    isSaveLastUrl: true,
    tokenApiUrl: props.token_api_url,
    shopId: props.shop_id,
  })

  return (
    <AppProvider jotaiStore={jotaiStore}>
      <Suspense fallback={null}>
        <BookPurchase bookId={props.book_id} monthlyErrorCancelledCourses={props.monthly_error_cancelled_courses} />
      </Suspense>
    </AppProvider>
  )
}

export default BookPurchaseApp
